export function terbilang(angka_nilai) {
   const angka_nilai_string   = angka_nilai.toString();
   var check = angka_nilai_string.indexOf(".");

   var nilai1 = null;
   var nilai2 = null;

   if(check !== -1){
      const nilai = angka_nilai_string.split(".");
      nilai1      = nilai[0];
      nilai2      = nilai[1];
   }

   

   // =====konversi angka belakang koma menjadi terbilang=====================================
   const nilai2_1    = check !== -1 ? nilai2.substr(0,1) : 0;
   const nilai2_2    = check !== -1 ? nilai2.substr(1,2) : 0;
   const kata_koma   = ['Nol','Satu','Dua','Tiga','Empat','Lima','Enam','Tujuh','Delapan','Sembilan'];
   // ========================================================================================
   
   const bilangan    = check !== -1 ? nilai1 : angka_nilai_string;
   const angka       = ['0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0'];
   const kata        = ['','Satu','Dua','Tiga','Empat','Lima','Enam','Tujuh','Delapan','Sembilan'];
   const tingkat     = ['','Ribu','Juta','Milyar','Triliun'];
    
   const panjang_bilangan = bilangan.length;
 
   if(bilangan==="0" || bilangan==="undefined"){
      return "0 Rupiah";
   }

   /* pengujian panjang bilangan */
   if(panjang_bilangan > 15){
      return "Diluar Batas";
   }
 
   /* mengambil angka-angka yang ada dalam bilangan, dimasukkan ke dalam array */
   for(let i = 1; i <= panjang_bilangan; i++){
      angka[i] = bilangan.substr(-(i),1);
   }
 
   let i = 1;
   let j = 0;
   let kaLimat = "";
 
 
   /* mulai proses iterasi terhadap array angka */
   while(i <= panjang_bilangan){
    
      let subkaLimat = "";
      let kata1 = "";
      let kata2 = "";
      let kata3 = "";
       
      /* untuk Ratusan */
      if(angka[i+2] !== "0"){
         if(angka[i+2] === "1"){
            kata1 = "Seratus";
         }else{
            kata1 = kata[angka[i+2]] + " Ratus";
         }
      }
       
      /* untuk Puluhan atau Belasan */
      if(angka[i+1] !== "0"){
         if(angka[i+1] === "1"){
            if(angka[i] === "0"){
               kata2 = "Sepuluh";
            }else if(angka[i] === "1"){
                  kata2 = "Sebelas";
            }else{
                  kata2 = kata[angka[i]] + " Belas";
            }
         } else {
            kata2 = kata[angka[i+1]] + " Puluh";
         }
      }
    
      /* untuk Satuan */
      if(angka[i] !== "0"){
         if(angka[i+1] !== "1"){
            kata3 = kata[angka[i]];
         }
      }
    
      /* pengujian angka apakah tidak nol semua, lalu ditambahkan tingkat */
      if((angka[i] !== "0") || (angka[i+1] !== "0") || (angka[i+2] !== "0")){
         subkaLimat = kata1+" "+kata2+" "+kata3+" "+tingkat[j]+" ";
      }
    
      /* gabungkan variabe sub kaLimat (untuk Satu blok 3 angka) ke variabel kaLimat */
      kaLimat = subkaLimat + kaLimat;
      i = i + 3;
      j = j + 1;
   }
 
   /* mengganti Satu Ribu jadi Seribu jika diperlukan */
   if((angka[5] === "0") && (angka[6] === "0")){
      kaLimat = kaLimat.replace("Satu Ribu","Seribu");
   }
   
   return kaLimat + "Koma "+kata_koma[nilai2_1]+" "+kata_koma[nilai2_2]+" Rupiah";

}


// WEBPACK FOOTER //
// ./src/_utils/terbilang.js